<template>
	<div class='promise-wrap'>
		<h1>我的承诺</h1>
		<div class="promise-table">
			<div class="flex flex-row-between promise-header">
				<p>序号</p>
				<p>承诺事项</p>
				<p>承诺主体</p>
				<p>发起单位</p>
			</div>
			<div class="flex flex-row-between promise-body" v-for="(item , index) in list" :key="item.id">
				<p>{{index+1}}</p>
				<p>{{item.matter}}</p>
				<p>{{item.realname}}</p>
				<p>{{item.enterpriseClaimName}}</p>
			</div>
		</div>

		<empty v-if="!list.length" />
	</div>
</template>

<script>
import { getMyPromise } from '@/api'
import empty from '@/components/empty'
export default {
	components: {
		empty,
	},
	data() {
		return {
			list: []
		}
	},
	created() {
		const { path } = this.$route;

		this.$emit('userEmit', path)
	},
	mounted() {
		this.getList();
	},
	methods: {
		getList(page = 1) {
			getMyPromise({ current: page }).then(res => {
				const { records, size, total } = res;
				this.$set(this, 'list', records || []);
			})
		}
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' scoped>
	.promise-wrap {
		padding-left: 20px;
		& > h1 {
			color: $red;
			font-size: 20px;
			font-weight: 600;
			padding: 40px 0;
			text-align: left;
		}

		.promise-table {
			& > .promise-header {
				font-size: 17px;
				font-weight: 400;
				background: #f4f4f4;
				border: 1px solid #e7e8ea;
			}
			& > .promise-header,
			& > .promise-body {
				p {
					padding: 8px 0;
					flex-basis: 28%;
					text-align: center;
					&:first-of-type {
						flex-basis: 10%;
					}
					&:last-of-type {
						flex-basis: 35%;
					}
				}
			}
		}
	}
</style>